import { analytics } from 'utils/analytics';
import { useRef } from 'react';

export const commonAnalyticsEvent = {
  elementType: 'button',
  elementBlock: 'header',
  elementName: 'horizontalMenu',
};

export const useHorizontalMenuAnalyticsEvent = () => {
  const isTouchMoveEventSent = useRef(false);

  const handleItemClick = (elementText: string) => {
    analytics.sendEvent('GA:clickButton', {
      ...commonAnalyticsEvent,
      elementText,
    });
  };

  const handleTouchMove = () => {
    if (!isTouchMoveEventSent.current) {
      analytics.sendEvent('GA:clickButton', {
        ...commonAnalyticsEvent,
        elementText: 'scroll',
      });
      isTouchMoveEventSent.current = true;
    }
  };

  return { handleItemClick, handleTouchMove };
};
